import { render } from "./lei-dashboard.vue?vue&type=template&id=bb9b136c&scoped=true&ts=true"
import script from "./lei-dashboard.vue?vue&type=script&lang=ts"
export * from "./lei-dashboard.vue?vue&type=script&lang=ts"

import "./lei-dashboard.vue?vue&type=style&index=0&id=bb9b136c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb9b136c"]])

export default __exports__